import type { TFunction } from "i18next";

import type { RequestFeedbackRequestType } from "@/services/requestFeedbackService";

/**
 * What to call a survey row's source request, in one place.
 *
 * WHY A RECORD AND NOT A TERNARY. Three screens each wrote
 * `type === "accountant" ? typeAccountant : typeNotarial`, so every value that
 * was not `"accountant"` — a third member added to the union later included —
 * would have been labelled "Escribano público" on the ratings pages. The same
 * shape, in the mail adapter, is what sent consumers a profession's name that
 * was not theirs.
 *
 * THE SET IS GENUINELY CLOSED, unlike `ProfessionSlug`. `requestType` says
 * which TABLE the rated request lives in — `notarial_request` or
 * `accountant_request` — not which profession handled it, and a new profession
 * does not add a table: RFQ work lives in `quote_request` and is rated through
 * its own path. So the protection that fits here is exhaustiveness rather than
 * an open lookup with a fallback: `Record<RequestFeedbackRequestType, …>` makes
 * a new union member a COMPILE ERROR in this one file, which is the signal a
 * ternary silently swallowed.
 */
const LABEL_KEYS: Record<RequestFeedbackRequestType, string> = {
  notarial: "ratings.page.typeNotarial",
  accountant: "ratings.page.typeAccountant",
};

/** The order the filter offers them in, and the only list of them in the UI. */
export const REQUEST_FEEDBACK_REQUEST_TYPES = Object.keys(
  LABEL_KEYS,
) as RequestFeedbackRequestType[];

export function requestTypeLabel(
  t: TFunction,
  type: RequestFeedbackRequestType,
): string {
  return t(LABEL_KEYS[type]);
}
